import mixpanel from 'mixpanel-browser';

mixpanel.init('3422ce9292d6693d5656d7e75c2696d0', {
  debug: true, // optional
});

export default mixpanel;